import React from 'react'
import { Detail } from './style'

export default ({ children, grow = true }) => (
    <Detail grow={grow}>{children}</Detail>
)
